export default __webpack_public_path__ + "static/media/simunye_debt.9fb4f16f.png";